<template>
  <div v-if="filter && loadingFilters"></div>
  <div v-else>
    <v-toolbar
      class="toolbar-element"
      light
      absolute
      flat
      height="90em"
      v-if="toolbar"
    >
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title">{{
          toolbarTitle
        }}</v-toolbar-title>
        <slot name="toolbar-table"></slot>
        <v-spacer></v-spacer>
      </template>
      <v-flex :xs4="$vuetify.breakpoint.smAndUp" v-if="searchText">
        <v-text-field
          v-model="search"
          solo
          light
          append-icon="search"
          :label="searchText"
          single-line
          hide-details
          flat
        ></v-text-field>
      </v-flex>
    </v-toolbar>
    <div :class="{ 'spacing-top': toolbar }">
      <slot name="before-filters"></slot>
      <v-card-actions class="filter-bar mb-0 pb-0 dates date-filter-bar">
        <v-spacer></v-spacer>
        <template v-if="filter">
          <template v-for="header in getDateHeaders(headers)">
            <DatePickerForm
              class="date-filter"
              v-model="filters[header.value]"
              :label="header.text"
              clearable
              :key="header.text"
            >
            </DatePickerForm>
          </template>
        </template>
      </v-card-actions>
      <v-card-actions class="filter-bar mb-0 pb-0">
        <div class="text-grey mr-2 pt-2 mt-2">{{ totalItems }} resultados</div>
        <v-spacer></v-spacer>
        <template v-if="filter">
          <!--torneo-->
          <v-layout row wrap>
          <v-flex xs6 pl-2>
          <template>
          <v-autocomplete
            ref="informeAutocomplete"
            light
            v-model="informe"
            chips
            prependIcon="fa-users"
            :items="listInforme"
            label="Informe"
            item-text="description"
            item-value="pk"
            v-on:change="fillFecha"
            no-data-text="No hay datos disponibles"
            :rules="[rules]"
            :error-messages="errorMessages"
          ></v-autocomplete>
          </template>
           </v-flex>
          <!--Fecha-->
      <v-flex xs3>
        <DatePickerForm
              class="date-filter"
              v-model="fechaDesde"
              label="Fecha de carga desde"
              clearable
              key="fecha1"
            >
            </DatePickerForm>
      </v-flex>
      <v-flex xs3>
        <DatePickerForm
              class="date-filter"
              v-model="fechaHasta"
              label="Fecha de carga hasta"
              clearable
              key="fecha2"
            >
            </DatePickerForm>
      </v-flex>
      <v-flex xs6 pl-2>
        <SelectItems v-model="club" :items="listClubItems" itemText="nombre" itemValue="id" prepend-icon="fa-users"
                     label="Clubes" :loading="loadingClubs" ></SelectItems>
      </v-flex>
      <v-flex xs5 pl-2>
        <SelectItems v-model="campo" :items="listCamposItems" itemText="description" itemValue="description" prepend-icon="fa-list"
                     label="Campos"></SelectItems>
      </v-flex>
       <v-flex xs1 pl-2>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="submitFiltering" flat>
              <v-icon color="primary">search</v-icon>
            </v-btn>
            <span>Filtrar</span>
          </v-tooltip>
          <slot name="after-filters"></slot>
          </v-flex>

        </v-layout>
        </template>
      </v-card-actions>
      <div class="white-box">
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          :rows-per-page-items="[10, 25, 50]"
          rows-per-page-text="Ítems por página:"
          class="table-element dense-table-header mt-2"
          hide-actions
          light
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr class="table-header">
              <template v-for="header in props.headers">
                <th
                  :key="header.text"
                  v-if="!(header.hasOwnProperty('visible') && !header.visible)"
                  :class="[
                    'header-title',
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    `text-xs-${header.align}`
                  ]"
                  @click="changeSort(header)"
                >
                  <span class="header-title white--text">{{
                    header.text
                  }}</span>
                  <v-icon
                    color="white"
                    small
                    v-if="
                      !(header.hasOwnProperty('sortable') && !header.sortable)
                    "
                    >arrow_upward</v-icon
                  >
                </th>
              </template>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <slot
              name="first-column"
              :item="props.item"
              v-if="slotName === 'first-column'"
            ></slot>
            <td
              v-for="(property, index) in properties"
              :key="property"
              :class="['table-row', getAlignment(index)]"
            >
              <div :class="['limit-height', 'limit-width', getWidth(index)]">
                {{
                  getFieldValue(props.item, index) || getDefaultValue(property)
                }}
              </div>
            </td>
            <slot
              name="second-last-column"
              :item="props.item"
              v-if="slotName === 'second-last-column'"
            ></slot>
            <td
              v-if="actionButtonsName"
              class="text-xs-right table-row"
              :key="'action'"
            >
              <component :is="actionButtonsName" :item="props.item"></component>
            </td>
          </template>

          <template slot="no-data">
            <div class="text-xs-center" v-if="loading">Cargando datos...</div>
            <div class="text-xs-center" v-else>No hay datos disponibles</div>
          </template>
        </v-data-table>
        <div class="text-xs-right pagination-element">
          <v-pagination
            light
            v-model="pagination.page"
            :length="pages"
            :total-visible="7"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformeAuditoriaActionButton from '../../features/informes-auditorias/components/InformeAuditoriaActionButton'
import { paginationMixin } from '../../mixins/paginationMixin'
import DatePickerForm from './DatePickerForm'
import SelectItems from '../../common/ui/SelectItems'

export default {
  mixins: [paginationMixin],
  props: {
    headers: Array,
    path: String,
    filterPath: String,
    actionButtonsName: String,
    properties: Array,
    filter: Boolean,
    slotName: String,
    toolbar: Boolean,
    toolbarTitle: String,
    searchText: String,
    defaults: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      listInforme: [],
      informe: '',
      listFechaItems: [],
      fecha: [],
      listClubItems: [],
      club: [],
      campo: [],
      listCamposItems: [],
      loadingClubs: true,
      errorMessages: [],
      fechaDesde: null,
      fechaHasta: null
    }
  },

  components: {
    DatePickerForm,
    InformeAuditoriaActionButton,
    SelectItems
  },

  methods: {
    selectAll (header) {
      let selectedValues = this.filters[header.value]
      let allValues = this.columnValueList(header.value)
        .slice()
        .map(item => item.value)

      if (selectedValues.length === allValues.length) {
        this.filters[header.value] = []
      } else {
        this.filters[header.value] = allValues
      }
      this.$forceUpdate()
    },
    getFieldValue (item, index) {
      let propertyList = this.properties[index].split('.')
      let fieldValue = item
      for (let property of propertyList) {
        if (property) {
          fieldValue = fieldValue[property]
        }
      }
      return fieldValue
    },
    getDefaultValue (property) {
      return this.defaults.hasOwnProperty(property)
        ? this.defaults[property]
        : ''
    },
    getArrayWithoutLastItem (array) {
      return array.slice(0, array.length - 1)
    },
    getDateHeaders (array) {
      let dateHeaders = []
      let headers = this.getArrayWithoutLastItem(array)
      for (var i = 0; i < headers.length; i++) {
        if (headers[i].dateFilterField) {
          dateHeaders.push(headers[i])
        }
      }
      return dateHeaders
    },
    getAlignment (index) {
      let alignment = this.headers[index].align
      return alignment ? `text-xs-${alignment}` : 'text-xs-center'
    },
    getWidth (index) {
      let header = this.headers[index]
      return header.value === 'description' ? 'observation-text' : ''
    },
    fetchInformesItems () {
      this.loading = true
      this.axios
        .get(`informe-auditoria/reportes-para-clubs?modulo=1`)
        .then(response => {
          this.listInforme = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    getFilteringPath () {
      let filterPath = ''
      if (this.informe !== '' && this.informe !== undefined) {
        filterPath += `&informe=${this.informe}`
      }
      if (this.fechaDesde !== '' && this.fechaDesde !== undefined && this.fechaDesde !== null && this.fechaDesde !== 'null') {
        filterPath += `&fechaDesde=${this.fechaDesde}`
      }
      if (this.fechaHasta !== '' && this.fechaHasta !== undefined && this.fechaHasta !== null && this.fechaHasta !== 'null') {
        filterPath += `&fechaHasta=${this.fechaHasta}`
      }
      for (let club of this.club) {
        filterPath += `&club[]=${club}`
      }
      for (let campo of this.campo) {
        filterPath += `&campo[]=${campo}`
      }
      return filterPath
    },
    fetchCLubItems () {
      this.axios
        .get('informe-auditoria/clubes')
        .then(response => {
          this.listClubItems = response.data
          this.loadingClubs = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchCamposItems () {
      this.axios
        .get('informe-auditoria/campos')
        .then(response => {
          this.listCamposItems = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    submitFiltering () {
      if (this.$refs.informeAutocomplete.validate()) {
        this.fetchData()
      } else {
        this.errorMessages.push('Este campo es requerido')
      }
    }
  },
  computed: {

    rules () {
      if (this.informe !== '' & this.informe !== undefined) {
        return false
      } else {
        return !!this.informe || 'Este campo es requerido'
      }
    }
  },
  mounted () {
    this.fetchInformesItems()
    this.fetchCLubItems()
    this.fetchCamposItems()
    // this.fetchData()
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em;
}
.white-box {
  background-color: white;
}
.table-header {
  background-color: #293968;
}
.table-row {
  background-color: white;
  border-bottom: 1px solid #959ba6;
  color: #5f5b5b;
  font-size: 1.05em;
}
.limit-height {
  overflow: hidden;
  max-height: 4.5em;
}
.limit-width {
  overflow: hidden;
  max-width: 40em;
}
.observation-text {
  max-width: 15em;
}
.table-element {
  margin-top: 1em;
  font-family: SourceSansProRegular, sans-serif;
}
.header-title {
  font-size: 1.05em;
}
th.header-title {
  border-bottom: 7.5px solid #0bbad9;
}
.pagination-element {
  margin-top: 2em;
  padding-bottom: 1em;
}
.text-grey {
  color: #5f5b5b;
}
.filter-element {
  font-family: SourceSansProRegular, sans-serif;
  font-size: 1.1em;
  padding-right: 0.5em;
}
.select-element {
  max-width: 20em;
}
.filter-bar {
  margin-bottom: 0.5em;
}
.date-filter-bar {
  margin-right: 7em;
}
.date-filter {
  margin-right: 1em;
  margin-left: 1em;
}
</style>
